// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","681":"component---cache-caches-gatsby-plugin-offline-app-shell-js"}[chunkId] || chunkId) + "-" + {"245":"0730d001f3073184328e","391":"815ba9ea2849b4e0eb99","681":"525d35efe8a6a4bebec9"}[chunkId] + ".js";
};